import { z } from "zod";
import type { infer as zInfer } from "zod";

export const creditCardVerification = z.object({
  expiryMonth: z.string(),
  expiryYear: z.string(),
  name: z.string(),
  numberFirst: z.string(),
  numberLast: z.string(),
  remainingAttempts: z.number(),
  status: z.enum([
    "UnderThreshold",
    "Pending",
    "InProgress",
    "Complete",
    "Failed",
    "ManuallyValidated",
    "ManuallyVerified",
    "ThreeDsVerified",
    "NotRequired",
  ]),
});

export type CreditCardVerification = zInfer<typeof creditCardVerification>;
